import { render, staticRenderFns } from "./MinhasFeriasPage.vue?vue&type=template&id=1dc4b11d"
import script from "./MinhasFeriasPage.vue?vue&type=script&lang=js"
export * from "./MinhasFeriasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports